import { CollectionOrderDirection } from 'json-api-hooks';
import React, { FC } from 'react';

import Collection from '../../../../components/./Collection/Collection';
import CollectionItems from '../../../../components/./Collection/CollectionItems';
import Container from '../../../../components/Container';
import { PostalCodeResource } from '../../../../models';
import EventCard from '../../../../models/events/EventCard';
import { Size } from '../../../../theme/types';

const PostalCodeStreetsTab: FC<{ postalCode: PostalCodeResource }> = ({ postalCode }) => {
  return (
    <Container size={Size.Large}>
      <Collection
        opts={{
          filter: { future: ['true'], postalDigits: [postalCode.attributes.postalDigits.toString()] },
          order: { distance: CollectionOrderDirection.Asc, happensAt: CollectionOrderDirection.Asc },
        }}
        resourceType="events"
      >
        <CollectionItems<'events'>>{(item) => <EventCard item={item} key={item.id} />}</CollectionItems>
      </Collection>
    </Container>
  );
};

export default PostalCodeStreetsTab;
